<template>
<v-tabs
  v-model="active"
  color="rgba(208, 214, 233, 0.2)"
  slider-color="#6274af"
  @change="onChangeTab"
  grow
>
  <v-tab
    dark
    key="1"
    ref="tab1Head"
    class="text-none"
  >
    Vorschau
  </v-tab>
  <v-tab
    dark
    key="44"
    class="text-none"
  >
    Details
  </v-tab>
  <v-tab
    key="2"
    dark
    v-if="showPDF"
    class="text-none"
  >
    PDF
  </v-tab>
  <v-tab
    key="3"
    dark
    class="text-none"
  >
    Rohtext
  </v-tab>
  <v-tab
    key="4"
    dark
    class="text-none"
  >
    Verlauf
  </v-tab>
  <v-tab-item
    key="1"
  >
    <v-card flat :id="cardPreviewId">
      <v-card-text class="scroll" :style="pdfStyle" v-if="currentItem" :key="xxx">
        <img :src="thumb" :width="(pdfWidth) + 'px'" v-if="false && !showWarn">
        <img :src="thumb" :height="(pdfHeight) + 'px'" v-if="!showWarn">
        <div v-else class="pa-4">
          <span class="myWarning">{{thumbWarn}}</span>
        </div>
      </v-card-text>
      <v-card-actions style="height: 52px;">
        <v-layout row wrap justify-center>
          <v-flex xs9 sm8 md6 lg3>
            <v-layout>
              <v-btn small fab outline color="#6f6f6e" dark @click="prev" >
                <v-icon>keyboard_arrow_left</v-icon>
              </v-btn>
              <v-layout row wrap align-center>
                <v-flex>
                  {{currentPageNumber}} / {{pageCnt}}
                </v-flex>
              </v-layout>
              <v-btn small fab outline color="#6f6f6e" dark @click="forw">
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
              <v-btn small fab outline color="#6f6f6e" dark @click="zoomImage(-1)" :disabled="lock">
                <v-icon>zoom_out</v-icon>
              </v-btn>
              <v-btn small fab outline color="#6f6f6e" dark @click="zoomImage(1)" :disabled="lock">
                <v-icon>zoom_in</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>

  </v-tab-item>
  <v-tab-item
    key="44"
  >
    <v-card flat>
      <v-card-text class="scroll" :style="pdfStyle2" v-if="currentItem" >
        <TabDetail ref="tab1" :current-item="currentItem"></TabDetail>
      </v-card-text>
    </v-card>
  </v-tab-item>
  <v-tab-item
    key="2" v-if="showPDF"
  >
    <v-card flat>
      <v-card-text class="scroll" :style="pdfStyle">
        <div id="pdfContainer" v-if="!pdfError">
          <canvas id="the-canvas" class="BoxShadowPDF">
          </canvas>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap justify-center>
          <v-flex xs5 sm4 md4 lg3>
            <v-layout>
              <v-btn small fab outline color="#6f6f6e" dark @click="prev" :disabled="lock">
                <v-icon>keyboard_arrow_left</v-icon>
              </v-btn>
              <v-layout row wrap align-center>
                <v-flex>
                  {{currentPageNumber}} / {{pageCnt}}
                </v-flex>
              </v-layout>
              <v-btn small fab outline color="#6f6f6e" dark @click="forw" :disabled="lock">
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
              <v-btn small fab outline color="#6f6f6e" dark @click="zoom(-1)" :disabled="lock">
                <v-icon>zoom_out</v-icon>
              </v-btn>
              <v-btn small fab outline color="#6f6f6e" dark @click="zoom(1)" :disabled="lock">
                <v-icon>zoom_in</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-tab-item>
  <v-tab-item
    key="3"
  >
    <v-card flat>
      <v-card-text class="scroll" :style="pdfStyle" v-if="currentItem" >

        <v-card flat>
          <v-card-text v-if="currentItem && rawText">
            <pre v-html="rawText" style="text-align: left"></pre>
          </v-card-text>
          <v-card-actions>
            <v-layout row wrap justify-center>
              <v-flex xs12>
                <v-card color="rgba(208, 214, 233, 0.2)">
                  <v-container>
                    <v-layout row wrap v-if="!ocrOnWork">
                      <v-flex xs12 md8 lg8>
                        <v-card-text class="text-left">
                          <v-icon color="#6274af" class="pr-3">warning</v-icon>Fehlender Text oder kein Text zusehen?<br>
                          Dann starte für dieses Dokument die OCR Erkennung.<br>
                        </v-card-text>
                      </v-flex>
                      <v-flex xs12 md4 lg2>
                        <v-btn @click="startOCR()" outline color="#6f6f6e" dark class="mt-4 text-none">OCR Erkennung ausführen</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-if="ocrOnWork">
                      <v-flex xs8>
                        <v-card-text class="text-left">
                          <v-icon color="#6274af" class="pr-3">warning</v-icon>Der Service verarbeitet gerade diese Datei.<br>
                          Bitte schauen Sie etwas später nochmal rein.
                        </v-card-text>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-card-text>
      <v-card-actions style="height: 52px;">
        <v-layout row wrap justify-center>
          <v-flex xs5 sm4 md4 lg3>
            <v-layout>
              <v-btn small fab outline color="#6f6f6e" dark @click="prev" >
                <v-icon>keyboard_arrow_left</v-icon>
              </v-btn>
              <v-layout row wrap align-center>
                <v-flex>
                  {{currentPageNumber}} / {{pageCnt}}
                </v-flex>
              </v-layout>
              <v-btn small fab outline color="#6f6f6e" dark @click="forw">
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>

  </v-tab-item>
  <v-tab-item
    key="4"
  >
    <v-card flat>
      <v-card-text class="scroll" :style="pdfStyle2" v-if="currentItem" >
        <TabHistory ref="tab3"></TabHistory>
      </v-card-text>
    </v-card>
  </v-tab-item>
</v-tabs>
</template>

<script>
import sas from 'surfandscan'
import Vue from 'vue'
import $ from 'jquery'
import pdfjsLib from 'pdfjs-dist/webpack'
import moment from 'moment'
import TabDetail from './tabs/TabDetail'
import TabHistory from './tabs/TabHistory'
// https://rossta.net/blog/building-a-pdf-viewer-with-vue-part-1.html
export default {
  name: 'MyPDFViewer',
  components: {TabHistory, TabDetail},
  props: ['jobs'],
  data () {
    return {
      window: {
        width: 0,
        height: 0
      },
      showPDF: false,
      rawText: null,
      currentItem: null,
      xxx: 0,
      menu1: false,
      pdfStyle: 'overflow: auto',
      pdfStyle2: 'overflow: auto',
      pdfError: false,
      lock: false,
      url: null,
      scale: 1.8,
      historyText: null,
      hours: [],
      minutes: [],
      hour: 13,
      minute: 0,
      ocrOnWork: false,
      thumbOnWork: false,
      rawTextStyle: '',
      pdfWidth: 100,
      pdfHeight: 100,
      active: '1',
      documentError: null,
      taskId: null,
      pageOrder: null,
      rotateArr: null,
      currentPageNumber: 1,
      currentPage: null,
      pdf: null,
      myItem: null,
      renderTask: null,
      pageCnt: 0,
      cardPreviewId: 0,
      showWarn: false,
      thumbWarn: 'Der Service erstellt gerade die Vorschau für gewünschte Seite. Bitte schauen Sie später nochmal rein.',
      thumb: null,
      isNewFile: false,
      delDialog: false,
      dateFrom: '',
      dateFromObj: new Date(),
      dateFromPS: '',
      menu: false,
      dialog: false,
      isLoading: false,
      pageSync: {
        descending: true,
        page: 0,
        rowsPerPage: -1,
        sortBy: 'created',
        totalItems: -1
      }
    }
  },
  methods: {
    doClearFROM: function (d) {
      this.dateFromObj = null
      this.dateFromPS = ''
      this.dateFrom = ''
    },
    translate: function (n) {
      return Vue.i18n.translate(n)
    },
    prev: function () {
      this.currentPageNumber--
      this.currentPageNumber = Math.max(this.currentPageNumber, 1)
      if (this.showPDF) {
        this.renderPage(this.currentPageNumber)
      } else {
        this.updatePreview(this.currentPageNumber)
      }
    },
    reload: function () {
      console.log('should reload now')
    },
    onChangeTab: function (tabId) {
      console.log('onChangeTab', tabId, this.$refs)
      this.$eventHub.$emit('OnShowIdle', false)
      if (this.$refs['tab' + tabId] && this.$refs['tab' + tabId].open) {
        this.$refs['tab' + tabId].open(this.currentItem)
      }
      if (this.$refs['tab' + tabId] && this.$refs['tab' + tabId].showPDF) {
        this.$refs['tab' + tabId].showPDF()
      }
    },
    zoomImage: function (factor) {
      // this.pdfHeight += (120 * factor)
      this.pdfWidth += (120 * factor)
      this.pdfWidth = this.pdfWidth * 1
      this.pdfHeight += (220 * factor)
      this.pdfHeight = this.pdfHeight * 1
    },
    getDateTime: function (str) {
      return new Date(str).toLocaleDateString('de-DE') + ' ' + new Date(str).toLocaleTimeString('de-DE')
    },
    getDate: function (str) {
      return new Date(str).toLocaleDateString('de-DE')
    },
    zoom: function (factor) {
      this.scale += (0.2 * factor)
      if (this.scale < 0) {
        this.scale = Math.abs(this.scale)
      }
      if (this.scale > 1.8) {
        this.scale = 1.8
      }
      this.renderPage(this.currentPageNumber)
    },
    forw: function () {
      this.currentPageNumber++
      console.log('pdf', this.pdf)
      if (this.currentPageNumber > this.pageCnt) {
        this.currentPageNumber = this.pageCnt
      }
      if (this.showPDF) {
        this.renderPage(this.currentPageNumber)
      } else {
        this.updatePreview(this.currentPageNumber)
      }
    },
    getPDFStyle: function () {
      var h = this.window.height - 270
      this.pdfHeight = h
      this.pdfStyle = 'overflow:auto;height:' + h + 'px; max-height:' + h + 'px;'
      this.pdfStyle2 = 'overflow:auto;height:' + (h + 52) + 'px; max-height:' + (h + 52) + 'px;'
      this.rawTextStyle = 'overflow:auto;height:' + (h - 100) + 'px;'
      console.log('getPDFStyle', h)
    },
    updatePreview: function (pageNumber) {
      console.log('updatePreview', pageNumber)
      Vue.prototype.$dms.getPreviewUpdateOfItem(this.currentItem.sid, pageNumber - 1, this.getPreviewData)
    },
    getPreviewData: function (data) {
      console.log('getPreviewData', data)
      this.showWarn = false
      let item = data.files[0]
      this.thumb = item.thumb
      if (item.rawText) {
        this.rawText = item.rawText
      } else {
        this.rawText = ''
      }
      this.rawText = Vue.prototype.$dms.replaceAll(this.rawText, '>', '&gt;')
      this.rawText = Vue.prototype.$dms.replaceAll(this.rawText, '<', '&lt;')
      this.xxx = this.xxx + 1

      if ((!this.thumb || this.thumb.length() === 0)) {
        this.showWarn = true
        if ((this.thumbOnWork)) {
          this.thumbWarn = 'Der Service erstell gerade ein Vorschau für diese Seite. Bitte schauen Sie später nochmal rein.'
        } else {
          this.thumbWarn = 'Der Service konnte keine Vorschau für diese Seite erstellen.'
        }
      }
    },
    renderPage: function (pageNumber) {
      console.log('renderPage')
      this.currentPageNumber = pageNumber
      var cmp = this
      cmp.lock = true
      this.pdf.getPage(pageNumber).then(function (page) {
        console.log('Page loaded')
        cmp.currentPage = page
        var scale = cmp.scale
        var viewport = page.getViewport(scale)
        // Prepare canvas using PDF page dimensions
        var canvas = document.getElementById('the-canvas')
        var context = canvas.getContext('2d')

        var pdfContainer = $('#pdfContainer')

        canvas.height = viewport.height
        canvas.width = viewport.width

        if (canvas.width > pdfContainer.width()) {
          scale = pdfContainer.width() / canvas.width
          canvas.width = pdfContainer.width()
          viewport = page.getViewport(scale)
          canvas.height = viewport.height
          canvas.width = viewport.width
        }
        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: context,
          viewport: viewport
        }
        cmp.renderTask = page.render(renderContext)
        cmp.renderTask.promise.then(function () {
          console.log('Page rendered')
          cmp.lock = false
        }).catch(cmp.destroyRenderTask)
      })
    },
    beforeDestroy () {
      this.destroyPage(this.page)
    },
    destroyPage (page) {
      if (!page) return

      // PDFPageProxy#_destroy
      // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
      page._destroy()

      // RenderTask#cancel
      // https://mozilla.github.io/pdf.js/api/draft/RenderTask.html
      if (this.renderTask) this.renderTask.cancel()
    },
    destroyRenderTask () {
      this.lock = false
      if (!this.renderTask) return
      this.renderTask.cancel()
      delete this.renderTask
    },
    close: function () {
      if (this.$refs.tab1Head) {
        this.$refs.tab1Head.click()
      }

      try {
        var canvas = document.getElementById('the-canvas')
        var context = canvas.getContext('2d')
        context.clearRect(0, 0, canvas.width, canvas.height)
      } catch (e) {

      }
    },
    clear: function () {
      //
    },
    open: function (item) {
      let cmp = this
      this.ocrOnWork = false
      this.thumbOnWork = false
      this.thumb = ''
      this.currentPageNumber = 1
      cmp.currentItem = item
      this.thumb = item.thumb
      this.rawText = item.rawText
      this.rawText = Vue.prototype.$dms.replaceAll(this.rawText, '>', '&gt;')
      this.rawText = Vue.prototype.$dms.replaceAll(this.rawText, '<', '&lt;')
      cmp.cardPreviewId = 'cardPreview' + new Date().getTime()
      cmp.$eventHub.$emit('OnShowIdle', true)
      cmp.active = '3'
      this.pageCnt = item.pageCnt
      cmp.getPDFStyle()
      window.setTimeout(function () {
        cmp.pdfWidth = $('#' + cmp.cardPreviewId).width() * 0.85
        cmp.pdfHeight = $('#' + cmp.cardPreviewId).height() * 0.85
        console.log('cmp.pdfWidth', cmp.pdfWidth, '#' + cmp.cardPreviewId)
        cmp.getPDFStyle()
      }, 500)
      this.$nextTick(function () {
        cmp.checkJobs()
        if (cmp.$refs.tab1Head) {
          cmp.$refs.tab1Head.click()
        }
      })
    },
    checkJobs () {
      this.ocrOnWork = false
      this.thumbOnWork = false
      if (this.jobs) {
        for (let i = 0; i < this.jobs.length; i++) {
          let job = this.jobs[i]
          if (job.jobType === 'OCR') {
            this.ocrOnWork = true
          }
          if (job.jobType === 'THUMBNAIL') {
            this.thumbOnWork = true
          }
        }
      }
    },
    onDoneOCR: function (res) {
      console.log('onDoneOCR', res)
      if (res && res.ok === true && res.message) {
        if (res.code === 200) {
          try {
            let ocrData = JSON.parse(res.message)
            if (ocrData && ocrData.ocrText) {
              this.currentItem.rawText = ocrData.ocrText
              this.rawText = ocrData.ocrText
            }
          } catch (e) {

          }
        }
      }
    },
    startOCR: function () {
      console.log('startOCR')
      let cmp = this
      cmp.$eventHub.$emit('OnShowIdle', true)
      var url = sas.gbl_host + '/storage/item?method=OCR&type=files&guid=' + this.currentItem.guid + '&token=' + Vue.prototype.$api.getAuthToken()
      $.ajax({
        url: url,
        type: 'GET',
        dataType: 'jsonp',
        contentType: 'application/json; charset=utf-8;',
        async: false,
        crossDomain: true,
        headers: {
        },
        success: function (data) {
          console.log(data)
          cmp.onDoneOCR(data)
          cmp.$eventHub.$emit('OnShowIdle', false)
        },
        error: function (xhr, status, error) {
          cmp.$eventHub.$emit('OnShowIdle', false)
          console.log(xhr)
          console.log(status)
          console.log(error)

          cmp.fnError(xhr, status, error)
        }
      })
    },
    showPDF2: function () {
      var cmp = this
      console.log('showPDF2')
      cmp.getPDFStyle()
      var canvas = document.getElementById('the-canvas')
      if (canvas) {
        var context = canvas.getContext('2d')
        context.clearRect(0, 0, canvas.width, canvas.height)
      }

      let url = Vue.prototype.$dms.getFileDownloadURL(this.currentItem.guid)
      if (this.isNewFile) {
        url = sas.getDownloadTaskAsPDFURL(this.taskId, '', this.pageOrder, this.rotateArr)
      }
      console.log('showPDF', url)
      this.url = url
      cmp.pdfError = false
      var loadingTask = pdfjsLib.getDocument(url)
      loadingTask.promise.then(function (pdf) {
        console.log('PDF loaded', pdf)
        cmp.getPDFStyle()
        cmp.pdf = pdf
        cmp.pageCnt = pdf.numPages
        // Fetch the first page
        cmp.renderPage(1)
        cmp.$eventHub.$emit('OnShowIdle', false)
      }, function (reason) {
        // PDF loading error
        cmp.pdfError = true
        console.error('PDF Error', reason)
        cmp.$eventHub.$emit('OnShowIdle', false)
      })
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted () {
    // let cmp = this
    this.getPDFStyle()
    let i = 0
    for (i = 0; i < 23; i++) {
      this.hours.push(i)
    }
    for (i = 0; i < 59; i++) {
      this.minutes.push(i)
    }
    let d = new Date()
    this.minute = d.getMinutes()
    this.hour = d.getHours()
    d.setMinutes(0)
    d.setDate(1)
    d.setHours(0)
    d.setSeconds(0)
    this.dateFromObj = d
    this.dateFrom = d.toLocaleDateString('de-DE')
    let md = moment(d)
    this.dateFromPS = md.format('YYYY-MM-DD')
    this.historyText = ''
  }
}
</script>

<style scoped>
  .myWarning {
    background-color: orange;
    color: #404040;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/MyPDFViewer.vue